import { render, staticRenderFns } from "./input-readonly-with-copy.vue?vue&type=template&id=2bd5470f"
import script from "./input-readonly-with-copy.vue?vue&type=script&lang=js"
export * from "./input-readonly-with-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports